import { subscribe, emit, events } from './eventManager';

/**
 * Emits an event to notify subscribers that the Volume Based Pricing Model modal should be closed.
 *
 * Use this function when the user:
 * - decides to keep their current subscription terms
 * - updates their subscription terms
 *
 * No parameters are required here; subscribers handle any additional context.
 */
function closeModal() {
    emit(events.VOLUME_BASED_PRICING_MODEL, {});
}

/**
 * Subscribe to events emitted by the Volume Based Pricing Model modal.
 *
 * This allows components to respond when the modal is closed or when actions are taken
 * within the modal (e.g., viewing the cart, updating subscription terms).
 *
 * @param {Function} callback - Function to be called when the event is emitted.
 * @returns {Function} - A function that can be used to unsubscribe from the event.
 *
 * @example
 * const unsubscribe = subscribeToModal((data) => {
 *     console.log('Modal event received', data);
 * });
 * // Later, call unsubscribe() to stop listening
 */
function subscribeToModal(callback) {
    return subscribe(events.VOLUME_BASED_PRICING_MODEL, callback);
}

export default {
    closeModal,
    subscribeToModal,
};
